/**
 * Navigation composable for Seva module
 * Transforms navigation config with i18n translations
 */
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { sevaNavSections } from '../config/navigation.js'

export function useNavigation() {
  const { t } = useI18n()

  // Transform navigation sections with translations
  const navSections = computed(() => {
    return sevaNavSections.map((section) => ({
      title: section.titleKey ? t(section.titleKey) : '',
      items: section.items.map((item) => ({
        ...item,
        label: t(item.labelKey),
      })),
    }))
  })

  return {
    navSections,
  }
}
